import { useFieldArray, useFormContext } from "react-hook-form";
import { IUser } from "../../../types/Auth/user";
import PermissionTable from "./PermissionTable";
import { marketingPermissionValue } from "../../../utils/Permission/Marketing";

const MarketingPermissionTable = () => {
  const { control, watch } = useFormContext<IUser>();
  const { fields, replace } = useFieldArray({
    control,
    name: "marketing_permission",
    keyName: "genId",
  });

  const watchFieldArray = watch("marketing_permission");

  const controlledFields = fields.map((field, index) => {
    return {
      ...field,
      ...(watchFieldArray &&
        watchFieldArray.length > 0 &&
        watchFieldArray[index]),
    };
  });

  const resetArrayHandler = () => {
    replace(marketingPermissionValue);
  };

  return (
    <PermissionTable
      module={"marketing_permission"}
      controlledFields={controlledFields}
      resetArrayHandler={resetArrayHandler}
    />
  );
};

export default MarketingPermissionTable;
